import React, { useState, useEffect } from "react";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import AboutImg from "../assets/images/about-pic.png";
import { useNavigate, useParams } from 'react-router-dom'; // Import useParams

// import BellIcon from "../assets/icons/bell.svg"; // Assuming you have the bell icon SVG locally
interface UserProfile {
  id: number;
  userName: string;
  email: string;
  phoneNumber: string;
  azureToken: string;
  roleId: number;
  roleName: string;
  createdDate: string;
  updatedDate: string;
  status: string | null;
}
const About: React.FC<{ updateUserName: (newUserName: string) => void }> = ({ updateUserName }) => {

  const navigate = useNavigate();

  const [notificationOpen, setNotificationOpen] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [aboutContent, setAboutContent] = useState("");
  const [userName, setUserName] = useState('');
  const [errorMessage, setErrorMessage] = useState<string | null>(null); // To store error messages
  const [userProfile, setUserProfile] = useState<UserProfile | null>(null); // Store user profile data
  const [isProfileModalOpen, setIsProfileModalOpen] = useState(false); // Modal visibility state


  useEffect(() => {
    const fetchAboutContent = async () => {
      try {
        const response = await fetch('https://pamsapi.vofoxsolutions.com/api/About');
        //const response = await fetch('http://192.168.7.108:7448/api/About');

        if (!response.ok) {
          throw new Error(`Failed to fetch about content: ${response.status}`);
        }

        const data = await response.json();

        if (data.aboutContent) {
          setAboutContent(data.aboutContent);
        } else {
          throw new Error("Content field is missing in the response");
        }
      } catch (error) {
        console.error("Error fetching about content:", error);
        toast.error('Error fetching about content');
      }
    };

    fetchAboutContent();
  }, []);
  const toggleDropdown = () => {
    setDropdownOpen(!dropdownOpen);
  };
  useEffect(() => {
    const storedUserName = localStorage.getItem('userName');
    // console.log('Retrieved UserName from localStorage:', storedUserName); // Check what is retrieved
    if (storedUserName) {
      setUserName(storedUserName);
    }
    const handleStorageChange = () => {
      const updatedUserName = localStorage.getItem('userName');
      if (updatedUserName) {
        setUserName(updatedUserName);

      }
    };
    window.addEventListener('storage', handleStorageChange);
    return () => {
      window.removeEventListener('storage', handleStorageChange);

    };
  }, []);
  const fetchUserProfile = async () => {
    const token = localStorage.getItem("token"); // Get the stored token
    if (!token) {
      console.error('Token not found in localStorage');
      setErrorMessage('Session expired. Please log in again.');
      navigate('/home'); // Redirect to login page
      return; // Stop execution if token is not found
    }

    try {
      // console.log('Fetching user profile...');
      // console.log('Token:', token); // Log the token for debugging

      const response = await fetch('https://pamsapi.vofoxsolutions.com/api/User/GetUserProfile'
        //const response = await fetch('http://192.168.7.108:7448/api/User/GetUserProfile'
        , {
        method: 'GET',
        headers: {
          "Authorization": `Bearer ${token}`, // Add token to Authorization header
          "Content-Type": "application/json", // Ensure Content-Type is set
        },
      });

      // console.log('Response Status:', response.status); // Log the response status

      if (!response.ok) {
        throw new Error(`Failed to fetch user profile: ${response.status} ${response.statusText}`);
      }

      const data: UserProfile = await response.json();
      // console.log('Fetched User Profile:', data); 
      setUserProfile(data); // Save user profile to state
      setUserName(data.userName); // Update the username state
      updateUserName(data.userName); // Update the username in the parent component

      setIsProfileModalOpen(false); // Open the profile modal

      // Pass user profile data via navigate to profile page
      navigate('/profile', {
        state: {
          userName: data.userName,
          email: data.email,
          phoneNumber: data.phoneNumber,
        },
      });
    } catch (error) {
      console.error('Error fetching user profile:', error);
      toast.error("An error occurred while fetching user profile.");
    }
  };
  const handleLogout = () => {
    // Clear user session (localStorage, sessionStorage, or cookies)
    localStorage.removeItem('userToken'); // Example: remove the user token or session info
    sessionStorage.clear(); // Clear sessionStorage if needed
    // You can also clear cookies if used for session management

    // Redirect to the Register page
    navigate('/'); // Redirects to localhost:3000/register
  };
  return (
    <div className="h-screen overflow-hidden bg-magnolia">
      <div className="flex flex-col h-screen">
        <header className="flex items-center justify-between px-6 py-3 bg-white">
          <div>
            {/* <h1 className="text-lg font-semibold text-gray-700">Postal Address Mapping</h1> */}
          </div>
          <div className="flex items-center">
            {/* <div className="relative">
              <button
                onClick={() => setNotificationOpen(!notificationOpen)}
                className="flex mx-4 text-blue bg-indigo-50 focus:outline-none w-12 h-12 items-center justify-center rounded-full"
              >
                <img src={BellIcon} alt="Notifications" className="w-6 h-6 cursor-pointer" />
                <i className="pam-bell text-lg"></i>
              </button>
              {notificationOpen && (
                <div className="absolute right-0 z-10 mt-2 overflow-hidden bg-white rounded-lg shadow-xl w-80">
                  <NotificationItem
                    name="Sara Salah"
                    action="replied on"
                    target="Upload Image"
                    time="2m"
                  />
                  <NotificationItem
                    name="Slick Net"
                    action="start following you"
                    time="45m"
                  />
                  <NotificationItem
                    name="Jane Doe"
                    action="liked your reply on"
                    target="Test with TDD"
                    time="1h"
                  />
                  <NotificationItem
                    name="Abigail Bennett"
                    action="start following you"
                    time="3h"
                  />
                </div>
              )}
            </div> */}

            {/* <div className="relative">
              <button
                onClick={() => setDropdownOpen(!dropdownOpen)}
                className="relative border border-whitesmoke focus:outline-none flex rounded-full h-12 items-center px-2 gap-2"
              >
                <div className="w-8 h-8 overflow-hidden rounded-full">
                  <img
                    className="object-cover w-full h-full"
                    src="https://images.unsplash.com/photo-1528892952291-009c663ce843?auto=format&fit=crop&w=296&q=80"
                    alt="User avatar"
                  />
                </div>
                <p className="text-sm">Joan Mir</p>
              </button>
              {dropdownOpen && (
                <div className="absolute right-0 z-10 w-48 mt-2 bg-white rounded-md shadow-xl">
                  <DropdownItem text="Profile" />
                  <DropdownItem text="Products" />
                  <DropdownItem text="Logout" />
                </div>
              )}
            </div> */}
            <div className="flex justify-end items-center gap-6">
              {/* Bell Icon */}
              {/* <div className="relative"> */}
              {/* <img src={BellIcon} alt="Notifications" className="w-6 h-6 cursor-pointer" /> */}
              {/* Optionally add a notification count indicator */}

              {/* </div> */}

              {/* User Profile Dropdown */}
              <div className="relative m-3">
                <button
                  onClick={toggleDropdown}
                  className="relative border border-whitesmoke focus:outline-none flex rounded-full h-12 items-center px-2 gap-2"
                >
                  <div className="w-8 h-8 overflow-hidden rounded-full">
                    <img
                      className="object-cover w-full h-full"
                      src="https://cdn-icons-png.flaticon.com/128/18573/18573514.png"
                      alt="User Avatar"
                    />
                  </div>
                  <h1>{userName || 'Guest'}</h1>          </button>

                {dropdownOpen && (
                  <>
                    {/* Close dropdown when clicking outside */}
                    <div
                      onClick={() => setDropdownOpen(false)}
                      className="fixed inset-0 z-10 w-full h-full"
                    ></div>

                    {/* Dropdown menu */}
                    <div className="absolute right-0 z-20 w-48 mt-2 bg-white rounded-md">
                      <button
                        onClick={fetchUserProfile}
                        className="block w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-indigo-600 hover:text-white"
                      >
                        Profile
                      </button>
                      {/* <a href="#" className="block px-4 py-2 text-sm text-gray-700 hover:bg-indigo-600 hover:text-white">
                  Products
                </a> */}
                      <button
                        onClick={handleLogout}
                        className="block w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-indigo-600 hover:text-white"
                      >
                        Log out
                      </button>              </div>
                  </>
                )}
              </div>
            </div>
          </div>
        </header>

        <main className="flex-1 overflow-x-hidden overflow-y-hidden ">
          <div className="container px-6 py-6 mx-auto ">
            <h4 className="text-base sm:text-lg text-dark font-semibold">
              About
            </h4>
            <div className="w-full mt-6">
              {/* Updated div with the box style */}
              <div className="w-full p-8 bg-white rounded-lg ">
                <div className="text-center">
                  <img
                    className="hidden md:inline-block"
                    src={AboutImg}
                    alt="About PAM"
                  />
                  <h4 className="text-base sm:text-xl text-dark font-semibold md:mt-6 mb-4">
                    Postal Address Mapping (PAM)
                  </h4>
                  <p className="text-sm text-jetgrey w-full lg:w-3/4 m-auto">
                    {aboutContent || 'Loading...'}
                  </p>
                </div>
              </div>
            </div>
            <footer className="w-full mt-44">
              <div className="px-6 py-6 bg-white shadow-shadow1 rounded-md">
                <p className="text-center text-jetgrey text-sm">
                  GET ME THERE. © 2024
                </p>
              </div>
            </footer>
          </div>
        </main>
      </div>

      <ToastContainer />
    </div>
  );
};

const NotificationItem: React.FC<{
  name: string;
  action: string;
  target?: string;
  time: string;
}> = ({ name, action, target, time }) => (
  <a
    href="#"
    className="flex items-center px-4 py-3 -mx-2 text-gray-600 hover:text-white hover:bg-indigo-600"
  >
    <img
      className="object-cover w-8 h-8 mx-1 rounded-full"
      src="https://via.placeholder.com/150"
      alt={name}
    />
    <p className="mx-2 text-sm">
      <span className="font-bold">{name}</span> {action}{" "}
      {target && <span className="font-bold text-indigo-400">{target}</span>} .{" "}
      {time}
    </p>
  </a>
);

const DropdownItem: React.FC<{ text: string }> = ({ text }) => (
  <a
    href="#"
    className="block px-4 py-2 text-sm text-gray-700 hover:bg-indigo-600 hover:text-white"
  >
    {text}
  </a>
);

export default About;
